var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPriceLow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1663652733613,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 25981,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M511.956509 97.502661c228.748844 0 414.204673 185.605232 414.204673 414.503479 0 228.91462-185.455829 414.489152-414.204673 414.489152-228.722238 0-414.118716-185.575556-414.118716-414.489152C97.837794 283.107893 283.234271 97.502661 511.956509 97.502661M679.212838 594.72919c10.111289-10.06524 9.307993-27.177989-1.692548-38.180578-11.001565-11.016915-27.624151-11.328-37.705763-1.218758-0.773619 0.803295-1.575892 1.339508-2.229784 2.260483l-97.441263 97.129154-0.327458-375.387599c0-13.410428-12.665461-24.234961-28.189016-24.234961-15.58086 0-27.5341 10.82351-27.5341 24.234961 0 1.039679-0.118704 1.961678 0 3.003404l-0.237407 372.355543-97.411587-97.100502c-0.683569-0.920976-1.486864-1.457188-2.25946-2.260483-10.080589-10.109242-26.703175-9.797134-37.734416 1.218758-10.971889 11.002588-11.745509 28.115338-1.694595 38.180578L487.721549 738.184439c3.122107 4.7727 7.788383 8.698103 13.736862 10.779507 3.034103 1.173732 6.303566 1.694595 9.605775 1.635243 0.326435 0.029676 0.594541 0.179079 0.892323 0.179079 0.26606 0 0.445138-0.118704 0.682545-0.118704 3.449565 0.060375 6.779404-0.475837 9.901511-1.725294 5.887081-2.051729 10.4367-5.916756 13.558807-10.600429L679.212838 594.72919",
    "p-id": 25982,
    fill: "#0dd78d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceLow);
export default __webpack_public_path__ + "static/media/priceLow.73d57d99.svg";
export { ForwardRef as ReactComponent };